import {css} from 'lit'; export default css`:host{--fly-floating-surface-overflow:hidden}.fly-multiselect-async__surface{--fly-select-surface-width:600px}`;
    